module.exports = __webpack_public_path__ + "img/touch-panel.041327df.jpg";